import {makeAutoObservable} from "mobx";

export default class MessagesStore {
    constructor() {
        this._data = {
            voltage: [
                {x: 0, y: 0},
                {x: 0, y: 0},
                {x: 0, y: 0},
            ],
            current: [
                {x: 0, y: 0},
                {x: 0, y: 0},
                {x: 0, y: 0},
            ],
            temperature: [],
            humidity: [],
            power: [],
        }
        this._location = {
            lat: 37.704961,
            lon: 55.757192,
        }
        this._code = []
        this._imei = '-'
        this._iccid = '-'
        this._fw = '-'
        this._hw = '-'
        this._pdo0 = false
        this._pdo1 = false
        this._RSSI = 0
        this._totalVoltage = 0
        this._totalCurrent = 0
        this._totalTemperature = 0
        this._totalHumidity = 0
        makeAutoObservable(this)
    }

    setData(action, newData) {
        switch (action) {
            case 'voltage':
                this._data.voltage = newData
                break;
            case 'current':
                this._data.current = newData
                break;
            case 'temperature':
                this._data.temperature = newData
                break;
            case 'humidity':
                this._data.humidity = newData
                break;
            case 'power':
                this._data.power = newData
                break;
            default:
                return;
        }
    }

    setLocation(action, newParam) {
        switch (action) {
            case 'lat':
                this._location.lat = newParam
                break;
            case 'lon':
                this._location.lon = newParam
                break;
            default:
                return;
        }
    }

    setImei(newImei){
        this._imei = newImei
    }

    setIccid(newIccid){
        this._iccid = newIccid
    }

    setFW(newFW){
        this._fw = newFW
    }

    setHW(newHW){
        this._hw = newHW
    }

    setPdo0(bool){
        this._pdo0 = bool
    }

    setPdo1(bool){
        this._pdo1 = bool
    }

    setCode(value){
        this._code = value
    }
    setRSSI(value){
        this._RSSI = value
    }

    setTotalVoltage(value){
        this._totalVoltage = value
    }
    setTotalCurrent(value){
        this._totalCurrent = value
    }
    setTotalTemperature(value){
        this._totalTemperature = value
    }
    setTotalHumidity(value){
        this._totalHumidity = value
    }

    get data() {
        return this._data
    }

    get location() {
        return this._location
    }

    get imei() {
        return this._imei
    }

    get iccid() {
        return this._iccid
    }

    get fw() {
        return this._fw
    }

    get hw() {
        return this._hw
    }

    get pdo0() {
        return this._pdo0
    }

    get pdo1() {
        return this._pdo1
    }

    get code() {
        return this._code
    }
    get RSSI() {
        return this._RSSI
    }

    get totalVoltage() {
        return this._totalVoltage
    }
    get totalCurrent() {
        return this._totalCurrent
    }
    get totalTemperature() {
        return this._totalTemperature
    }
    get totalHumidity() {
        return this._totalHumidity
    }
}